import {PageId} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {IDeleteDialogProps} from '@mintdata-wsp/wsp/ui/dialogs/DeleteDialog';
import {SurfacePagesOutline} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/outline/pages/SurfacePagesOutline';
import {ContextMenuTarget, IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import * as React from 'react';

export abstract class OutlineContextMenuProvider
{
    public static pagesDataSource(pageId:PageId):(target:ContextMenuTarget) => IContextMenuItem[]
    {
        return function contextMenuProviderForPage(target:ContextMenuTarget):IContextMenuItem[]
        {
            const {surfaceArea, surfacePagesPanel, dialogs} = controllers.ui;

            if( !(target instanceof HTMLElement) )
            {
                return [];
            }

            let result:IContextMenuItem[] = [
                {
                    label: 'Delete Page',
                    handler: () =>
                    {
                        dialogs.showDialog(Dialogs.Delete, false, {
                            message: 'Are you sure you want to delete this page?',
                            onClose: () =>
                            {
                                dialogs.hideDialog(Dialogs.Delete);
                                const instance:SurfacePagesOutline = surfacePagesPanel.getPagesComponentInstance();

                                if( instance )
                                    instance.focusLastActiveElement();
                            },
                            onClickDelete: () =>
                            {
                                surfaceArea.removePage(pageId);
                                dialogs.hideDialog(Dialogs.Delete);

                                const instance:SurfacePagesOutline = surfacePagesPanel.getPagesComponentInstance();

                                if( instance )
                                    instance.focusLastActiveElement();
                            }
                        } as IDeleteDialogProps);
                    },
                    isDisabled: !surfaceArea.isPageRemoveAvailable()
                },
                {
                    label: 'Duplicate Page',
                    handler: () => surfaceArea.duplicatePage(pageId)
                },
                {
                    label: 'Mark as Starting Page',
                    handler: () => surfaceArea.markPageAsStarted(pageId),
                    isDisabled: pageId === surfaceArea.getState().startPageId
                }
            ];

            if( pageId !== surfaceArea.getActivePage().id )
            {
                result.push({
                    isSeparator: true
                });
                result.push({
                    label: <span>Overlay on <b>{surfaceArea.getActivePage().name}</b></span>,
                    handler: () => surfaceArea.showOverlay(pageId)
                });
            }

            return result;
        };
    }

    public static sectionsDataSource(sectionName:string):(target:ContextMenuTarget) => IContextMenuItem[]
    {
        return function contextMenuProviderForSection(target:ContextMenuTarget):IContextMenuItem[]
        {
            if( !(target instanceof HTMLElement) )
                return [];

            const {surfacePagesPanel} = controllers.ui;

            return [
                {
                    label: 'Delete Section',
                    handler: () => surfacePagesPanel.showRemoveSectionConfirmDialog(sectionName)
                }
            ];
        };
    }
}
